import { render, staticRenderFns } from "./relationGraph.vue?vue&type=template&id=10b0111e&scoped=true"
import script from "./relationGraph.vue?vue&type=script&lang=js"
export * from "./relationGraph.vue?vue&type=script&lang=js"
import style0 from "./relationGraph.vue?vue&type=style&index=0&id=10b0111e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0111e",
  null
  
)

export default component.exports